var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path10, _path11, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomePageBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1940.71 346.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#ffffff;}.cls-2{font-size:28px;font-family:MyriadPro-Regular, Myriad Pro;letter-spacing:0em;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Home Page Banner") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.67,202.91c0,42.19-12.87,70.44-80.09,70.44-17.52,0-45.77-1.79-67.58-6.08V24.49l43.62-6.08v84C56.5,97.07,76.16,92.07,95.11,92.07c37.55,0,52.56,22.88,52.56,59.71Zm-104,31.82a198.64,198.64,0,0,0,26.1,1.43c28.61,0,34.33-11.44,34.33-31.82V150.71c0-14-6.08-21.46-22.17-21.46-12.16,0-27.53,5-38.26,10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.91,269.77V24.49l43.62-6.08V269.77Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.54,95.64V217.21c0,9.3,3.94,13.95,13.95,13.95,10.73,0,29.68-6.44,45.41-14.66V95.64h43.62V269.77H358.27L354,255.11c-21.81,10.73-49.35,18.24-69.73,18.24-29,0-39.33-20.38-39.33-51.49V95.64Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M493.42,237.59a182.56,182.56,0,0,0,53.28-8.22l6.79,32.9c-19.66,7.5-43.26,11.08-64,11.08-54.71,0-73.66-25.39-73.66-67.22V160c0-36.83,16.45-67.93,72.23-67.93s68.29,32.53,68.29,70.08v37.18h-96.9v8.94C459.45,229.37,467,237.59,493.42,237.59Zm-34-73.3h55.43v-8.58c0-16.45-5-27.89-26.46-27.89s-29,11.44-29,27.89Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M782.67,211.85c0,38.62-17.16,61.5-57.56,61.5a240.35,240.35,0,0,1-46.48-5v71.87L635,346.29V95.64h34.69L674,110.3C689.35,99.22,707.23,92.07,729,92.07c35,0,53.63,20.73,53.63,60.42Zm-104,19.66c11.44,2.51,26.1,4.65,38.61,4.65,15.74,0,21.81-7.51,21.81-23.24v-61.5c0-14.3-5.36-22.17-21.45-22.17-14.3,0-29.68,7.15-39,15.73Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1055.12,138.21c-16.8,7.51-30.39,15.38-46.12,25.39V269.77H965.38V95.64h36.83l3.23,27.68c9.66-6.43,30.58-16.7,46-21Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1370.84,202.91c0,42.19-12.87,70.44-80.09,70.44-17.52,0-45.77-1.79-67.58-6.08V24.49l43.62-6.08v84c12.88-5.37,32.54-10.37,51.49-10.37,37.55,0,52.56,22.88,52.56,59.71Zm-104,31.82a198.64,198.64,0,0,0,26.1,1.43c28.61,0,34.33-11.44,34.33-31.82V150.71c0-14-6.08-21.46-22.17-21.46-12.16,0-27.53,5-38.26,10Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1394.08,269.77V24.49l43.62-6.08V269.77Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1539.6,237.59a182.56,182.56,0,0,0,53.28-8.22l6.79,32.9c-19.66,7.5-43.26,11.08-64,11.08C1481,273.35,1462,248,1462,206.13V160c0-36.83,16.45-67.93,72.23-67.93s68.29,32.53,68.29,70.08v37.18h-96.89v8.94C1505.64,229.37,1513.14,237.59,1539.6,237.59Zm-34-73.3h55.42v-8.58c0-16.45-5-27.89-26.46-27.89s-29,11.44-29,27.89Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1653.63,
    y: 223.85,
    width: 105.7,
    height: 42.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1721.65,
    y: 170.53,
    width: 105.7,
    height: 42.25,
    transform: "translate(9.6 -74.27) rotate(2.4)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1771.52,
    y: 223.85,
    width: 51.24,
    height: 42.25
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1882.33,
    y: 38.42,
    width: 51.24,
    height: 42.25,
    transform: "translate(285.39 -946) rotate(30)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1773.94,
    y: 70.15,
    width: 105.7,
    height: 42.25,
    transform: "translate(3601.13 535.38) rotate(-168.81)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1762.24,
    y: 9.86,
    width: 105.7,
    height: 42.25,
    transform: "translate(3589.66 413.66) rotate(-168.81)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1706.9,
    y: 61.59,
    width: 51.24,
    height: 42.25,
    transform: "translate(3439.93 388.01) rotate(-172.6)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1672.39,
    y: 117.57,
    width: 169.1,
    height: 42.25,
    transform: "translate(15.92 -135.05) rotate(4.42)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1653.63,
    y: 172.56,
    width: 51.24,
    height: 42.25
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1123.77,92.07c-17.61,0-39.08,2.68-55.2,7l3.36,34a240.63,240.63,0,0,1,45.77-4.87c27.89,0,33.25,6.79,33.25,26.1v18.24h-41.84c-35.39,0-50.77,13.58-50.77,49,0,30,13.59,51.85,45.41,51.85A95.25,95.25,0,0,0,1155.6,258l3.22,11.8h35.75V155C1194.57,111.37,1178.48,92.07,1123.77,92.07ZM1151,229.73a68.59,68.59,0,0,1-32.9,8.93c-13.58,0-17.52-5.36-17.52-17.51,0-13.23,3.94-17.17,18.24-17.17H1151Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M866.34,92.07c-17.61,0-39.08,2.68-55.2,7l3.36,34a240.53,240.53,0,0,1,45.76-4.87c27.89,0,33.26,6.79,33.26,26.1v18.24H851.68c-35.4,0-50.77,13.58-50.77,49,0,30,13.59,51.85,45.41,51.85A95.19,95.19,0,0,0,898.16,258l3.22,11.8h35.76V155C937.14,111.37,921.05,92.07,866.34,92.07Zm27.18,137.66a68.66,68.66,0,0,1-32.9,8.93c-13.59,0-17.52-5.36-17.52-17.51,0-13.23,3.93-17.17,18.24-17.17h32.18Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(1857.96 274.7)"
  }, "TM")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePageBanner);
export default __webpack_public_path__ + "static/media/HomePageBanner.1d9b1a63d85693210403ccaea2373aa2.svg";
export { ForwardRef as ReactComponent };